import { createSlice } from "@reduxjs/toolkit"

const initialCustomersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  customerForEdit: undefined,
  lastError: null
}
export const callTypes = {
  list: "list",
  action: "action"
}

export const topupSlice = createSlice({
  name: "topup",
  initialState: initialCustomersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false
      } else {
        state.actionsLoading = false
      }
    },
    startCall: (state, action) => {
      state.error = null
      if (action.payload.callType === callTypes.list) {
        // state.listLoading = true
      } else {
        state.actionsLoading = true
      }
    },
    // getCustomerById
    customerFetched: (state, action) => {
      state.actionsLoading = false
      state.customerForEdit = action.payload.customerForEdit
      state.error = null
    },
    // findCustomers
    customersFetched: (state, action) => {
      const { totalCount, entities } = action.payload
      state.listLoading = false
      state.error = null
      state.entities = entities
      state.totalCount = totalCount
    },
    // createCustomer
    customerCreated: (state, action) => {
      state.actionsLoading = false
      state.error = null
      state.entities = [action.payload.topup, ...state.entities]
    },
    // updateCustomer
    customerUpdated: (state, action) => {
      state.error = null
      state.actionsLoading = false
      state.entities = state.entities.map(entity => {
        if (entity._id === action.payload.package._id) {
          return action.payload.package
        }
        return entity
      })
    },
    // deleteCustomer
    customerDeleted: (state, action) => {
      state.error = null
      state.actionsLoading = false
      state.entities = state.entities.filter(el => el.id !== action.payload.id)
    },
    // deleteCustomers
    customersDeleted: (state, action) => {
      state.error = null
      state.actionsLoading = false
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      )
    },
    // customersUpdateState
    customersStatusUpdated: (state, action) => {
      state.actionsLoading = false
      state.error = null
      const { ids, status } = action.payload
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status
        }
        return entity
      })
    },
    clear: (state) => {
      state.actionsLoading = false
      state.entities = null
    }
  }
})
